/*
    Create by Pierre Marsot on 05/12/2017
*/
import {get, putApi, removeApi, postApi} from '../tools/api';
import {sendMessageError, sendMessageSuccess} from './toast';

export const LOAD_BALISE_SUCCESS = 'LOAD_BALISE_SUCCESS';
export const LOAD_BALISE_ERROR = 'LOAD_BALISE_ERROR';

export const LOAD_USERS_BALISE_SUCCESS = 'LOAD_USERS_BALISE_SUCCESS';
export const LOAD_USERS_BALISE_ERROR = 'LOAD_USERS_BALISE_ERROR';

export const REMOVE_BALISE_SUCCESS = 'REMOVE_BALISE_SUCCESS';
export const REMOVE_BALISE_ERROR = 'REMOVE_BALISE_ERROR';

export const DISSOCIER_UTILISATEUR_BALISE_SUCCESS = 'DISSOCIER_UTILISATEUR_BALISE_SUCCESS';
export const DISSOCIER_UTILISATEUR_BALISE_ERROR = 'DISSOCIER_UTILISATEUR_BALISE_ERROR';

export const DECLENCHER_BALISE_SUCCESS = 'DECLENCHER_BALISE_SUCCESS';
export const DECLENCHER_BALISE_ERROR = 'DECLENCHER_BALISE_ERROR';

export const ARRETER_BALISE_SUCCESS = 'ARRETER_BALISE_SUCCESS';
export const ARRETER_BALISE_ERROR = 'ARRETER_BALISE_ERROR';

export function loadBalise(idBalise) {
    return new Promise((resolve, reject) => {
        if (!idBalise || idBalise.length === 0) {
            return reject("Erreur lors de la récupération de l'identifiant de la balise");
        }

        get("/api/societe/balises/" + idBalise)
            .then((response) => {
                if (response && response.balise) {
                    return resolve(response.balise);
                } else {
                    return reject("Erreur lors de la récupération de la balise");
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    return reject(response.error);
                }
                return reject("Erreur lors de la récupération de la balise");
            });
    });
}

function removeBaliseSuccess(idBalise) {
    return {
        type: REMOVE_BALISE_SUCCESS,
        id_balise: idBalise,
    };
}

function removeBaliseError() {
    return {
        type: REMOVE_BALISE_ERROR,
    };
}

export function removeBalise(idBalise) {
    return dispatch => {
        removeApi('/api/societe/balises/' + idBalise)
            .then(() => {
                return dispatch(removeBaliseSuccess(idBalise));
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                }
                return dispatch(removeBaliseError());
            });
    }
}

function loadUsersBaliseSuccess(payload) {
    return {
        type: LOAD_USERS_BALISE_SUCCESS,
        users_balise: payload.users,
    };
}

function loadUsersBaliseError() {
    return {
        type: LOAD_USERS_BALISE_ERROR,
    };
}

export function loadUsersBalise(idBalise, offset) {
    return dispatch => {
        if (!idBalise || idBalise.length === 0) {
            dispatch(sendMessageError("erreur_recuperation_identifiant_balise"));
            return dispatch(loadUsersBaliseError());
        }

        get('/api/societe/balises/' + idBalise + "/users", {
            offset: offset,
        })
            .then((response) => {
                console.log(response);
                if (response && response.users) {
                    return dispatch(loadUsersBaliseSuccess(response));
                } else {
                    dispatch(sendMessageError("erreur_recuperation_utilisateurs_balise"));
                    return dispatch(loadUsersBaliseError());
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                }
                return dispatch(loadUsersBaliseError());
            });
    }
}

export function countUsersBalise(idBalise) {
    return new Promise((resolve, reject) => {
        if (!idBalise || idBalise.length === 0) {
            return reject("erreur_recuperation_identifiant_balise");
        }

        get('/api/societe/balises/' + idBalise + "/users/count")
            .then((response) => {
                if (response && response.count) {
                    return resolve(response.count);
                } else {
                    return reject();
                }
            })
            .catch((response) => {
                return reject();
            });
    });
}

export function enService(balise) {
    if (!balise) {
        return false;
    }

    if (!balise._source) {
        return false;
    }

    return balise._source.etat === 'EN_SERVICE';
}

export function isActive(balise) {
    if (!balise) {
        return null;
    }

    if (!balise._source) {
        return null;
    }

    return balise._source.etat;
}

export function mettreEnServiceBalise(idBalise, adresse, lat, lon, postcode) {
    return new Promise((resolve, reject) => {
        if (!idBalise || idBalise.length === 0) {
            return reject("erreur_recuperation_identifiant_balise");
        }

        if (lat === 0.0) {
            return reject("erreur_recuperation_latitude_balise");
        }

        if (lon === 0.0) {
            return reject("erreur_recuperation_longitude_balise");
        }

        if(!postcode || postcode.length === 0) {
            return reject("postcode_vide");
        }

        putApi("/api/societe/balises/" + idBalise + "/mettre-en-service", {
            _source: {
                location: {
                    lat: lat,
                    lon: lon,
                },
                adresse: adresse,
                postcode: postcode,
            }
        })
            .then((response) => {
                if (response && response.balise) {
                    return resolve(response.balise);
                } else {
                    return reject('erreur_mise_en_service_balise');
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    return reject(response.error);
                } else {
                    return reject('erreur_mise_en_service_balise');
                }
            });
    });
}

function dissocierUtilisateurBaliseSuccess(idUser) {
    return {
        type: DISSOCIER_UTILISATEUR_BALISE_SUCCESS,
        id_user: idUser,
    };
}

function dissocierUtilisateurBaliseError() {
    return {
        type: DISSOCIER_UTILISATEUR_BALISE_ERROR,
    };
}

export function dissocierUtilisateurBalise(idBalise, idUser) {
    return dispatch => {
        removeApi("/api/societe/users/" + idUser + "/dissocier/balise/" + idBalise)
            .then(() => {
                return dispatch(dissocierUtilisateurBaliseSuccess(idUser));
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                }
                return dispatch(dissocierUtilisateurBaliseError());
            });
    };
}

function declencherBaliseSuccess(idBalise) {
    return {
        type: DECLENCHER_BALISE_SUCCESS,
    };
}

function declencherBaliseError(idBalise){
    return {
        type: DECLENCHER_BALISE_ERROR,
    };
}

export function declencherBalise(idBalise, idUser) {
    /*return dispatch => {
        postApi("/api/societe/balises/" + idBalise + "/mettre-en-alerte", {
            id_user: idUser,
        })
            .then(() => {
                dispatch(sendMessageSuccess("Balise bien déclenchée"));
                dispatch(loadBalise(idBalise));
                return dispatch(declencherBaliseSuccess(idBalise))
            })
            .catch(() => {
                dispatch(sendMessageError("Erreur lors du déclenchement de la balise"));
                return dispatch(declencherBaliseError(idBalise));
            });
    };*/

    return new Promise((resolve, reject) => {
        postApi("/api/societe/balises/" + idBalise + "/mettre-en-alerte", {
            id_user: idUser,
        })
            .then((response) => {
                return resolve();
            })
            .catch((response) => {
                return reject();
            });
    });
}

function arreterBaliseSuccess(idBalise) {
    return {
        type: ARRETER_BALISE_SUCCESS,
    };
}

function arreterBaliseError(idBalise){
    return {
        type: ARRETER_BALISE_ERROR,
    };
}

export function arreterBalise(idBalise) {
    return dispatch => {
        postApi("/api/societe/balises/" + idBalise + "/supprimer-en-alerte")
            .then(() => {
                dispatch(sendMessageSuccess("Balise bien arrêtée"));
                dispatch(loadBalise(idBalise));
                return dispatch(arreterBaliseSuccess(idBalise))
            })
            .catch(() => {
                dispatch(sendMessageError("Erreur lors de l'arrêt de la balise"));
                return dispatch(arreterBaliseError(idBalise));
            });
    };
}

/**
 * Permet de récupérer les utilisateurs liés à une balise
 * @param idBalise
 */
export function getUsersBindToBalise(idBalise) {
    return new Promise((resolve, reject) => {
        get('/api/societe/balises/' + idBalise + '/users')
            .then((response) => {
                if(response && response.users) {
                    return resolve(response.users);
                } else {
                    return reject();
                }
            })
            .catch((response) => {
                console.log(response);
                return reject();
            })
    });
}

/**
 * Permet de récupérer les utilisateurs en autocomplete liés à une balise
 * @param idBalise
 * @param value
 */
export function autocompleteUsersBindToBalise(idBalise, value) {
    return new Promise((resolve, reject) => {
        postApi('/api/societe/balises/' + idBalise + '/users/search', {
            id_balise: idBalise,
            value: value,
        })
            .then((response) => {
                if(response && response.users) {
                    return resolve(response.users);
                } else {
                    return reject();
                }
            })
            .catch((response) => {
                return reject();
            })
    });
}

/**
 * Permet de modifier les informations d'une balise
 */
export function updateBalise(balise) {
    return new Promise((resolve, reject) => {
        console.log(balise);
       if(!balise)
       {
           console.log("Erreur lors de la récupérat");
            return reject("Erreur lors de la récupération des données de la balise");   
       }
        
       putApi("/api/societe/balises/" + balise._id, balise)
        .then((response) => {
           return resolve(response.balise);
        })
        .catch((response) => {
           return reject(response.error);
       });
    });
}



// WEBPACK FOOTER //
// ./src/actions/balise.js